import './JewelleryDetailCustomize.svelte.css';
/* src/components/JewelleryDetail/JewelleryDetailCustomize.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let div2;
	let h3;
	let img;
	let img_src_value;
	let t0;
	let div1;
	let p0;
	let t4;
	let p1;
	let t8;
	let p2;
	let t10;
	let div0;
	let em;
	let a;
	let t11;

	return {
		c() {
			div2 = element("div");
			h3 = element("h3");
			img = element("img");
			t0 = space();
			div1 = element("div");
			p0 = element("p");
			p0.innerHTML = `紐色：<strong class="svelte-famf5d">8種類</strong>からお選びいただけます。`;
			t4 = space();
			p1 = element("p");
			p1.innerHTML = `金具：<strong class="svelte-famf5d">16種類</strong>からお選びいただけます。`;
			t8 = space();
			p2 = element("p");
			p2.textContent = "「無料カスタマイズする」ボタンをクリックしてください。";
			t10 = space();
			div0 = element("div");
			em = element("em");
			a = element("a");
			t11 = text("カスタマイズする");
			if (!src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].assetsUrl + '/common/h3_itempage_selectoption.webp')) attr(img, "src", img_src_value);
			attr(img, "width", "328");
			attr(img, "height", "32");
			attr(img, "alt", "この商品はパーツの無料カスタマイズができます。");
			attr(img, "loading", "lazy");
			attr(h3, "class", "svelte-famf5d");
			attr(p0, "class", "svelte-famf5d");
			attr(p1, "class", "svelte-famf5d");
			attr(p2, "class", "svelte-famf5d");
			attr(a, "class", "lit-gradient-button gradient-green svelte-famf5d");
			attr(a, "href", /*customizeUrl*/ ctx[1]);
			attr(em, "class", "svelte-famf5d");
			attr(div0, "class", "customize-button svelte-famf5d");
			attr(div1, "class", "jewellery-customize-contents svelte-famf5d");
			attr(div2, "class", "jewellery-customize svelte-famf5d");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, h3);
			append(h3, img);
			append(div2, t0);
			append(div2, div1);
			append(div1, p0);
			append(div1, t4);
			append(div1, p1);
			append(div1, t8);
			append(div1, p2);
			append(div1, t10);
			append(div1, div0);
			append(div0, em);
			append(em, a);
			append(a, t11);
		},
		p(ctx, [dirty]) {
			if (dirty & /*jewellery*/ 1 && !src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].assetsUrl + '/common/h3_itempage_selectoption.webp')) {
				attr(img, "src", img_src_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { jewellery } = $$props;
	const customizeUrl = jewellery.assetsUrl.replace('img/lithos_philia', 'select_jewellery_design/?vt=4&code=' + jewellery.code);

	$$self.$$set = $$props => {
		if ('jewellery' in $$props) $$invalidate(0, jewellery = $$props.jewellery);
	};

	return [jewellery, customizeUrl];
}

class JewelleryDetailCustomize extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { jewellery: 0 });
	}
}

export default JewelleryDetailCustomize;